import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import {
  FlexAlignDirective as FlexLayoutFlexAlignDirective,
  MediaMonitor,
} from '@angular/flex-layout';

@Directive({
  selector: `
    [flLayoutFlexAlign],
    [flLayoutFlexAlign.mobile],
    [flLayoutFlexAlign.tablet],
    [flLayoutFlexAlign.desktop-small],
    [flLayoutFlexAlign.desktop-large],
    [flLayoutFlexAlign.desktop-xlarge],
    [flLayoutFlexAlign.desktop-xxlarge],
  `,
})
export class FlexAlignDirective extends FlexLayoutFlexAlignDirective {
  constructor(monitor: MediaMonitor, elRef: ElementRef, renderer: Renderer2) {
    super(monitor, elRef, renderer);
  }

  @Input('flLayoutFlexAlign')
  set align(val: any) {
    this._cacheInput('align', val);
  }
  @Input('flLayoutFlexAlign.mobile')
  set alignMobile(val: any) {
    this._cacheInput('alignMobile', val);
  }
  @Input('flLayoutFlexAlign.tablet')
  set alignTablet(val: any) {
    this._cacheInput('alignTablet', val);
  }
  @Input('flLayoutFlexAlign.desktop-small')
  set alignDesktopSmall(val: any) {
    this._cacheInput('alignDesktopSmall', val);
  }
  @Input('flLayoutFlexAlign.desktop-large')
  set alignDesktopLarge(val: any) {
    this._cacheInput('alignDesktopLarge', val);
  }
  @Input('flLayoutFlexAlign.desktop-xlarge')
  set alignDesktopXLarge(val: any) {
    this._cacheInput('alignDesktopXLarge', val);
  }
  @Input('flLayoutFlexAlign.desktop-xxlarge')
  set alignDesktopXXLarge(val: any) {
    this._cacheInput('alignDesktopXXLarge', val);
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/app/@shared/ui/layout/flex-align.directive.ts